"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Button_1 = __importDefault(require("@/components/Button"));
const Alert_svg_1 = __importDefault(require("@/assets/Alert.svg"));
const style_1 = require("./style");
function AlertDialog({ isOpen, onClose, dialogTitle, text, dismissActionLabel, proceedWithActionLabel, onDismiss, onProceed, isOnProceedButtonDisabled, isActionLoading = false }) {
    return (react_1.default.createElement(Dialog_1.default, { open: isOpen, onClose: onClose },
        react_1.default.createElement(style_1.StyledDialogContent, null,
            react_1.default.createElement(style_1.StyledAlert, { src: Alert_svg_1.default, alt: "alert" }),
            react_1.default.createElement(Typography_1.default, { variant: "h3" }, dialogTitle),
            react_1.default.createElement("div", { style: { textAlign: "center" } },
                react_1.default.createElement(style_1.StyledDialogContentText, null, text))),
        react_1.default.createElement(style_1.StyledDialogActions, null,
            react_1.default.createElement(Button_1.default, { label: dismissActionLabel, onClick: onDismiss, color: "secondary", variant: "outlined" }),
            react_1.default.createElement(Button_1.default, { label: proceedWithActionLabel, onClick: onProceed, isLoading: isActionLoading, disabled: isOnProceedButtonDisabled }))));
}
exports.default = AlertDialog;
